import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiStar } from 'react-icons/fi';
import { FaQuoteLeft } from 'react-icons/fa';

const Testimonials = () => {
  const reviews = [
    { 
      name: "Dr. Brady Steineck", 
      role: "CEO, Community Health Care", 
      text: "Our partnership with GiANT has been remarkable... Our turnover has dropped significantly, and physicians have grown and stepped up into leadership." 
    },
    { 
      name: "Tanielle", 
      role: "CNM, OhioHealth", 
      text: "Becky was a wonderful presenter. She made the presentation engaging and fun. It wasn’t uncomfortable interacting and sharing at all." 
    },
    { 
      name: "Amanda", 
      role: "Nurse Manager, OhioHealth", 
      text: "Very helpful both professionally and personally. Becky makes you think outside the box and get out of your comfort zone." 
    }
  ];

  return (
    <section id="testimonials" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-24">
          <h2 className="text-5xl font-black text-brand-black mb-4">What Leaders <span className="text-brand-purple">Say.</span></h2>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto font-medium">
            Real feedback from leaders who have moved from overwhelmed to empowered.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {reviews.map((r, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -10 }}
              className="bg-gray-50 p-10 rounded-[2.5rem] border border-gray-100 relative overflow-hidden group flex flex-col"
            >
              <SafeIcon icon={FaQuoteLeft} className="absolute -top-4 -right-4 w-32 h-32 text-brand-purple/5 group-hover:text-brand-purple/10 transition-colors" />
              <div className="flex space-x-1 mb-6 relative z-10">
                {[1, 2, 3, 4, 5].map(s => <SafeIcon key={s} icon={FiStar} className="text-brand-purple w-4 h-4 fill-current" />)}
              </div>
              <p className="text-lg font-bold text-brand-black mb-8 leading-relaxed relative z-10 flex-grow">"{r.text}"</p>
              <div className="relative z-10">
                <div className="font-black text-brand-black text-lg">{r.name}</div>
                <div className="text-brand-purple font-bold text-xs uppercase tracking-wider">{r.role}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;